
/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  ConfirmAvailabilityDetailsRequest,
  ProfileAvailability,
  SimpleError,
} from '../models';
import {
    ConfirmAvailabilityDetailsRequestFromJSON,
    ConfirmAvailabilityDetailsRequestToJSON,
    ProfileAvailabilityFromJSON,
    ProfileAvailabilityToJSON,
    SimpleErrorFromJSON,
    SimpleErrorToJSON,
} from '../models';

export interface ConfirmAvailabilityDetailsOperationRequest {
    profileId: string;
    token: string;
    confirmAvailabilityDetailsRequest: ConfirmAvailabilityDetailsRequest;
}

export interface GetAvailabilityRequest {
    profileId: string;
    token: string;
}

/**
 * 
 */
export class PublicUpdateAvailabilityApi extends runtime.BaseAPI {

    /**
          */
    async confirmAvailabilityDetailsRaw(requestParameters: ConfirmAvailabilityDetailsOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ProfileAvailability>> {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError(
                'profileId',
                'Required parameter "profileId" was null or undefined when calling confirmAvailabilityDetails().'
            );
        }

        if (requestParameters['token'] == null) {
            throw new runtime.RequiredError(
                'token',
                'Required parameter "token" was null or undefined when calling confirmAvailabilityDetails().'
            );
        }

        if (requestParameters['confirmAvailabilityDetailsRequest'] == null) {
            throw new runtime.RequiredError(
                'confirmAvailabilityDetailsRequest',
                'Required parameter "confirmAvailabilityDetailsRequest" was null or undefined when calling confirmAvailabilityDetails().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['token'] != null) {
            queryParameters['token'] = requestParameters['token'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<ProfileAvailability>({
            path: `/profile/public-api/{profileId}/availability/update`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ConfirmAvailabilityDetailsRequestToJSON(requestParameters['confirmAvailabilityDetailsRequest']),
        }, initOverrides);

        if (response._data) { response._data=ProfileAvailabilityFromJSON(response._data); }
        return response;
    }

    /**
          */
    async confirmAvailabilityDetails(requestParameters: ConfirmAvailabilityDetailsOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ProfileAvailability> {
        const response = await this.confirmAvailabilityDetailsRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
          */
    async getAvailabilityRaw(requestParameters: GetAvailabilityRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ProfileAvailability>> {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError(
                'profileId',
                'Required parameter "profileId" was null or undefined when calling getAvailability().'
            );
        }

        if (requestParameters['token'] == null) {
            throw new runtime.RequiredError(
                'token',
                'Required parameter "token" was null or undefined when calling getAvailability().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['token'] != null) {
            queryParameters['token'] = requestParameters['token'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ProfileAvailability>({
            path: `/profile/public-api/{profileId}/availability/update`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ProfileAvailabilityFromJSON(response._data); }
        return response;
    }

    /**
          */
    async getAvailability(requestParameters: GetAvailabilityRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ProfileAvailability> {
        const response = await this.getAvailabilityRaw(requestParameters, initOverrides);
        return response._data;
    }

}
